<ng-container *ngIf="mode=='row'; else dropdownView">
  <div data-test-id="locale-picker-lib-locale"  class="lib-locale">
    <div data-test-id="locale-picker-simple"  class="simple-row" *ngIf="(config$|async) as config">
      <a [attr.data-test-id]="'locale-picker-lib-'+locale" role="button" *ngFor="let locale of availableLocale" (click)="changeLang(locale, config)" [class.active]="(activeLocale$ | async) == locale">
        {{ getDisplayLocale(locale) }}
      </a>
    </div>
  </div>
 </ng-container>


<ng-template #dropdownView>
  <div data-test-id="locale-picker-locale"  class="lib-locale" *ngIf="(config$|async) as config">
    <button data-test-id="locale-picker-text-button"  class="ee-text-button" [matMenuTriggerFor]="localeMenu" #open="matMenuTrigger">
      <img data-test-id="locale-picker-img"  src="/assets/synlab-header/globe-icon.png" alt="globe icon">
      {{ activeLocale$ | async  }}
      <mat-icon data-test-id="locale-picker-icon"  color="primary" *ngIf="open.menuOpen==false">keyboard_arrow_down</mat-icon>
      <mat-icon data-test-id="locale-picker-icon"  color="primary" *ngIf="open.menuOpen==true">keyboard_arrow_up</mat-icon>
    </button>
    <mat-menu data-test-id="locale-picker-localeMenu"  #localeMenu="matMenu">
      <ng-container *ngFor="let locale of availableLocale; let i = index">
        <button [attr.data-test-id]="'locale-picker-locale-locale'+i"  mat-menu-item class="lib-locale-locale" [class.use-flags]="useFlags" (click)="changeLang(locale, config)" [class.active]="(activeLocale$ | async) == locale">
          <mat-icon data-test-id="locale-picker-icon"   color="primary">check</mat-icon>
          {{ locale | slice: 0: 2 }}
          <span data-test-id="locale-picker-span"  *ngIf="useFlags" [ngClass]="['fp', lookupCountry(locale)]"></span>
        </button>
      </ng-container>
    </mat-menu>
  </div>
</ng-template>
